import React from 'react';
import { motion } from 'framer-motion';

const PoliticaPrivacidad = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-neutral-900 text-neutral-300 py-32 px-6 md:px-12"
    >
      <div className="max-w-3xl mx-auto">
        
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-12 tracking-tighter">
          Política de Privacidad
        </h1>
        
        <div className="space-y-10 leading-relaxed">
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Responsable del Tratamiento</h2>
            <p className="mb-4">
              De conformidad con lo establecido en el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD), te informamos de que los datos personales recabados en esta web serán tratados por:
            </p>
            <ul className="list-none space-y-3 text-neutral-400 bg-neutral-800/50 p-6 rounded-lg border border-neutral-800">
              <li><strong className="text-white">Titular / Razón Social:</strong> Javier Barroso González</li>
              <li><strong className="text-white">NIF / CIF:</strong> 79083760P</li>
              <li><strong className="text-white">Domicilio:</strong> Santa Cruz de Tenerife, Tenerife (España).</li>
              <li><strong className="text-white">Correo electrónico:</strong> contacto@firststudio.es</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Datos Recopilados y Finalidad</h2>
            <p className="mb-4">
              A través de nuestro sitio web y correo electrónico, recopilamos únicamente los datos estrictamente necesarios (como tu nombre, correo electrónico o teléfono) cuando decides contactarnos voluntariamente.
            </p>
            <p className="bg-neutral-800/30 p-5 border border-neutral-800 rounded text-neutral-300">
              <strong className="text-white">Finalidad exclusiva:</strong> La única finalidad de recabar estos datos es poder ponernos en contacto contigo para atender tus consultas, enviarte presupuestos y presentarte las propuestas comerciales de diseño y desarrollo que nos hayas solicitado. <strong>No</strong> utilizaremos tus datos para suscribirte a boletines automatizados (newsletters) ni te enviaremos spam.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Legitimación</h2>
            <p>
              La base legal que nos permite tratar tus datos personales es tu <strong>consentimiento expreso</strong>. Al enviarnos un correo electrónico o rellenar un formulario de contacto para solicitarnos información o un presupuesto, estás aceptando que tratemos tus datos con esa finalidad específica.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Conservación y Terceros</h2>
            <ul className="list-disc pl-5 space-y-3 text-neutral-400">
              <li><strong>Conservación:</strong> Mantendremos tus datos de contacto únicamente durante el tiempo necesario para gestionar tu solicitud, elaborar la propuesta comercial y realizar el seguimiento de la misma, o mientras exista una relación contractual entre ambas partes.</li>
              <li><strong>Terceros:</strong> En First Studio valoramos tu privacidad. Tus datos <strong>no serán cedidos, vendidos ni compartidos con ninguna otra empresa o tercero</strong>, salvo que exista una obligación legal que nos obligue a ello (por ejemplo, para facturación si acabas contratando nuestros servicios).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Derechos del Usuario</h2>
            <p className="mb-4">
              Como propietario de tus datos, la ley te ampara para que puedas ejercer en cualquier momento tus derechos de Acceso, Rectificación, Cancelación y Oposición (conocidos como derechos ARCO), así como el derecho a la limitación del tratamiento y a la portabilidad de los datos.
            </p>
            <p>
              Para ejercer cualquiera de estos derechos, o simplemente pedirnos que borremos tu información de nuestros registros tras enviarte una propuesta, solo tienes que enviarnos un correo electrónico a <strong className="text-white">contacto@firststudio.es</strong> adjuntando una copia de tu DNI para que podamos verificar tu identidad.
            </p>
          </section>

        </div>
      </div>
    </motion.div>
  );
};

export default PoliticaPrivacidad;
